// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TbUtils18 from "./TbUtils18.bs.js";
import * as TeamPlannerHex18 from "./TeamPlannerHex18.bs.js";

function HexPreview18(Props) {
  var unitId = Props.unitId;
  var unitItems = Props.unitItems;
  var starLevel = Props.starLevel;
  var traitCounts = Props.traitCounts;
  var modifier = Props.modifier;
  return React.createElement("g", {
              transform: "translate(3, 0)"
            }, React.createElement("g", {
                  className: "scale-50 sm:scale-100"
                }, React.createElement(TeamPlannerHex18.Unit.make, {
                      isDragging: false,
                      hexSize: 50,
                      hex: {
                        unit: TbUtils18.Content.decodeStr(unitId),
                        items: unitItems,
                        starLevel: starLevel,
                        chosenTrait: 0,
                        modifier: modifier
                      },
                      colNum: 0,
                      rowNum: 0,
                      onRemove: (function (param) {
                          
                        }),
                      onRemoveItem: (function (param, param$1, param$2) {
                          
                        }),
                      onUpdateHex: (function (param, param$1, param$2) {
                          
                        }),
                      onToggleMech: (function (param, param$1, param$2) {
                          
                        }),
                      traitCounts: traitCounts,
                      exaltedUnits: []
                    })));
}

var make = React.memo(HexPreview18);

export {
  make ,
  
}
/* make Not a pure module */
